import { isHeyApiQuery } from "@/lib/hey-api-query-key";
import type { QueryClient } from "@tanstack/react-query";

/**
 * Refresh every cached view of Hera operator / government users after a change
 * (create, edit, disable, re-enable, bulk upsert).
 *
 * Matching on the operation id also covers the list's several parameter
 * variants: the setup tabs ask for deleted users, the inspector pickers do not.
 *
 * `refetchType: "all"` covers list copies that are unmounted, e.g. the Setup
 * page's other users tab.
 */
export async function invalidateAdminUserQueries(
  queryClient: QueryClient,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({
      predicate: (query) => isHeyApiQuery(query.queryKey, "getAdminUsers"),
      refetchType: "all",
    }),
    queryClient.invalidateQueries({
      predicate: (query) => isHeyApiQuery(query.queryKey, "getAdminUser"),
    }),
  ]);
}
